import fp from "lodash/fp";

export default function mapAdditionalServices(formValues) {
	if (fp.isEmpty(formValues)) return;
	const mappedValues = {
		ach: formValues.ach,
		cashAdvance: formValues.cashAdvance,
		multiCurrency: formValues.multiCurrency,
		businessConnections: formValues.businessConnections,
		checkServices: formValues.checkServices,
		giftLoyalty: formValues.giftLoyalty,
		nailSoftGiftLoyalty: formValues.nailSoftGiftLoyalty,
		existingProvider: formValues.existingProvider,
		existingAcctNumber: formValues.existingAcctNumber,
		// Bundles
		bundles: formValues?.bundles || false,
		bundle1: formValues?.bundles?.bundle_1_name || "",
		priceBundle1: formValues?.bundles?.bundle_1_price,
		bundle2: formValues?.bundles?.bundle_2_name,
		priceBundle2: formValues?.bundles?.bundle_2_price,
		noteBundle: formValues?.bundles?.notes || "",
	};

	return mappedValues;
}
